(function () {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('consortium-expedientes', {
                parent: 'entity',
                url: '/consortium-expedientes?page&sort&search&code&type&nif&name&sn1&sn2&company_name',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumExpediente'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes.html',
                        controller: 'ConsortiumExpedienteController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    steps: ['$stateParams', 'Step', function ($stateParams, Step) {
                        return Step.query().$promise;
                    }],
                    status: ['$stateParams', 'GFileStatus', function ($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('consortium-expedientes.edit', {
                parent: 'consortium-expedientes',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_CONSORTIUM'],
                    pageTitle: 'ConsortiumExpediente'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes-detail.html',
                        controller: 'ConsortiumExpedienteDetailController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Administrar',
                    parent: 'consortium-expedientes'
                },
                resolve: {
                    entity: ['$stateParams', 'ConsortiumExpediente', function ($stateParams, ConsortiumExpediente) {
                        return ConsortiumExpediente.get({
                            id: $stateParams.id
                        }).$promise;
                    }],
                    processtypes: ['$stateParams', 'ProcessType', function ($stateParams, ProcessType) {
                        return ProcessType.query({ jurisdiction: 'ADMINISTRATIVA_CONSORCIOS' }).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function ($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function ($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-expedientes',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }],
                    status: ['$stateParams', 'GFileStatus', function ($stateParams, GFileStatus) {
                        return GFileStatus.query().$promise;
                    }]
                }
            })
            .state('consortium-expedientes.new', {
                parent: 'consortium-expedientes',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/consortium-expedientes/consortium-expedientes-new.html',
                        controller: 'ConsortiumExpedienteNewController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Nuevo',
                    parent: 'consortium-expedientes'
                },
                resolve: {
                    entity: function () {
                        return {
                            code: null,
                            id: null
                        };
                    },
                    processtypes: ['$stateParams', 'ProcessType', function ($stateParams, ProcessType) {
                        return ProcessType.query({ jurisdiction: 'ADMINISTRATIVA_CONSORCIOS' }).$promise;
                    }],
                    clients: ['$stateParams', 'GFileClients', function ($stateParams, GFileClients) {
                        return GFileClients.query().$promise;
                    }],
                    lawyers: ['$stateParams', 'Lawyers', function ($stateParams, Lawyers) {
                        return Lawyers.query().$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'consortium-expedientes',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }

})();
